import type { QuizPrivate } from '@repo/types/quiz';

import QuestionsSidebarHeader from '@/components/features/quiz/header/QuestionsSidebarHeader';
import QuizSectionCard from '@/components/features/quiz/quiz-resolver/QuizSectionCard';

interface QuizSectionsNavigationListProps {
  onNavigate?: (sectionIndex: number) => void;
  totalQuestions: number;
  quiz?: QuizPrivate;
}

export default function QuizSectionsNavigationList(quizSectionsNavigationListProps: QuizSectionsNavigationListProps) {
  const { quiz, totalQuestions, onNavigate } = quizSectionsNavigationListProps;
  return (
    <div className="space-y-3">
      <QuestionsSidebarHeader number={totalQuestions} />
      <div className="space-y-3">
        {quiz?.content.map((section, index) => (
          <QuizSectionCard navigateTo={onNavigate} section={section} sectionIndex={index} key={index} />
        ))}
      </div>
    </div>
  );
}
